/* eslint-disable react/prop-types */
import classes from "./content.module.scss";
import Label from "@/components-library/widgets/label";
import Radio from "@/components-library/widgets/radio";
import Flex from "@/components-library/layout/flex";
import classNames from "classnames";
function Content({ name, title, isSelected, onItemSelect, isLast }) {
  var label = name ? name : title;
  return (
    <Flex
      align="center"
      className={classNames(classes.content, {
        [classes.last]: isLast,
      })}
      direction="row"
      justify="flex-start"
      onClick={(event) => {
        onItemSelect({ name: label, event });
      }}
    >
      <Radio className={classes.radio} isChecked={isSelected} size="md" />
      {/*{isMultiSelect && (
        <Radio className={classes.radio} isChecked={isSelected} size="md" />
      )}
      {!isMultiSelect && (
        <Checkbox
          isChecked={isSelected}
          //isEnabled={true}
          className={classes.checkbox}
          //onClick={(event) => {onItemSelect({ name: label, event });}}
        />
      )}*/}
      <Label tag="p" align="start" size="md" color="secondary">
        {label}
      </Label>
    </Flex>
  );
}

export default Content;
